import React from 'react';
import { useManuals } from '../../../hooks/useEntities';
import YearModuleAnalyticsReport from '../components/YearModuleAnalyticsReport';

const ManualAnalyticsReport = () => (
  <YearModuleAnalyticsReport
    title="Manuals Analytics"
    description="Manuals created in the selected year — validity status and monthly volume."
    useData={useManuals}
    dateField="createdAt"
    getStatusLabel={(r) => r?.status || '—'}
    getSecondaryLabel={(r) => r?.manualType?.typeName || r?.manualType?.name || '—'}
    secondaryTitle="By manual type"
    getRowLabel={(r) =>
      r?.title || r?.code || (r?.id != null ? `#${r.id}` : '—')
    }
  />
);

export default ManualAnalyticsReport;
